import dlv from 'dlv';
import * as React from 'react';
import { EntityContext } from '../EntityContent/Shortcode';
import Galleries from '../Galleries';
function ProgressItem({ item }) {
    return (React.createElement("div", null,
        React.createElement("h3", null,
            item.description,
            " (",
            item.date,
            ")"),
        React.createElement(Galleries, { images: item.images })));
}
export default function Progress() {
    return (React.createElement(EntityContext.Consumer, null, entity => {
        if (!entity) {
            return null;
        }
        const progress = dlv(entity, 'progress');
        return (React.createElement("div", null, progress.map((item, idx) => (React.createElement(ProgressItem, { key: idx, item: item })))));
    }));
}
//# sourceMappingURL=Progress.js.map